import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "../context/AuthContext";
import {
    LayoutDashboard,
    BookOpen,
    Bot,
    FileText,
    Megaphone,
    Lightbulb,
    Users,
    GraduationCap,
    BarChart3,
    Brain,
    MessageSquare,
    HelpCircle,
    Wallet,
    Calendar,
    Building2,
    User,
    TrendingUp,
    Activity,
    Briefcase,
    FilePieChart,
    UserCircle,
    UserSearch,
    Mic,
    AlertTriangle,
    ClipboardCheck,
} from "lucide-react";

const ITEMS = {
    alumno: [
        { to: "/alumno/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        { to: "/alumno/lecciones", label: "Lecciones", icon: BookOpen, testId: "lecciones", expandable: "courses" },
        { to: "/alumno/calendario", label: "Calendario", icon: Calendar, testId: "calendario" },
        { to: "/alumno/tutor-ia", label: "Tutor IA", icon: Bot, testId: "tutor-ia" },
        { to: "/alumno/examenes", label: "Exámenes", icon: FileText, testId: "examenes" },
        { to: "/alumno/comunicados", label: "Comunicados", icon: Megaphone, testId: "comunicados" },
        { to: "/alumno/recomendaciones", label: "Recomendaciones", icon: Lightbulb, testId: "recomendaciones" },
        { to: "/alumno/evaluacion-oral", label: "Evaluación Oral", icon: Mic, testId: "evaluacion-oral" },
        { to: "/alumno/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
    profesor: [
        { to: "/profesor/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        { to: "/profesor/mis-cursos", label: "Mis Cursos", icon: Briefcase, testId: "mis-cursos", expandable: "courses" },
        { to: "/profesor/calendario", label: "Calendario", icon: Calendar, testId: "calendario" },
        { to: "/profesor/calificaciones", label: "Calificaciones", icon: BarChart3, testId: "calificaciones" },
        { to: "/profesor/reportes", label: "Reportes", icon: FilePieChart, testId: "reportes" },
        { to: "/profesor/evaluacion-oral", label: "Evaluación Oral", icon: Mic, testId: "evaluacion-oral" },
        { to: "/profesor/incidencias", label: "Incidencias", icon: AlertTriangle, testId: "incidencias" },
        { to: "/profesor/asistencia", label: "Asistencia", icon: ClipboardCheck, testId: "asistencia" },
        { to: "/profesor/asistente-ia", label: "Asistente IA", icon: Bot, testId: "asistente-ia" },
        { to: "/profesor/consultas", label: "Consultas del Colegio", icon: HelpCircle, testId: "consultas" },
        { to: "/profesor/mensajeria", label: "Mensajería", icon: MessageSquare, testId: "mensajeria" },
        { to: "/profesor/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
    psicologo: [
        { to: "/psicologo/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        { to: "/psicologo/perfiles", label: "Perfiles de Estudiantes", icon: Brain, testId: "perfiles" },
        { to: "/psicologo/perfiles-profesores", label: "Perfiles de Profesores", icon: Users, testId: "perfiles-profesores" },
        { to: "/psicologo/calendario", label: "Calendario", icon: Calendar, testId: "calendario" },
        { to: "/psicologo/mensajeria", label: "Mensajería", icon: MessageSquare, testId: "mensajeria" },
        { to: "/psicologo/consultas", label: "Consultas del Colegio", icon: HelpCircle, testId: "consultas" },
        { to: "/psicologo/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
    padre: [
        { to: "/padre/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        { to: "/padre/mi-hijo", label: "Mi Hijo", icon: User, testId: "mi-hijo" },
        { to: "/padre/calendario", label: "Calendario", icon: Calendar, testId: "calendario" },
        { to: "/padre/mensajeria", label: "Mensajería", icon: MessageSquare, testId: "mensajeria" },
        { to: "/padre/comunicados", label: "Comunicados", icon: Megaphone, testId: "comunicados" },
        { to: "/padre/consultas", label: "Consultas del Colegio", icon: HelpCircle, testId: "consultas" },
        { to: "/padre/incidencias", label: "Incidencias", icon: AlertTriangle, testId: "incidencias" },
        { to: "/padre/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
    administrativo: [
        { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        {
            to: "/admin/usuarios", label: "Gestión de Usuarios", icon: Users, testId: "usuarios",
            children: [
                { to: "/admin/alumnos/datos", label: "Datos del alumno" },
                { to: "/admin/alumnos/familia", label: "Familia" },
                { to: "/admin/alumnos/medico", label: "Datos médicos-psicológicos" },
                { to: "/admin/trabajadores", label: "Trabajadores" },
            ],
        },
        { to: "/admin/contratacion", label: "Contratación", icon: UserSearch, testId: "contratacion" },
        { to: "/admin/monedas", label: "Monedas", icon: Wallet, testId: "monedas" },
        { to: "/admin/calendario", label: "Calendario", icon: Calendar, testId: "calendario" },
        { to: "/admin/comunicados", label: "Comunicados", icon: Megaphone, testId: "comunicados" },
        { to: "/admin/horarios", label: "Horarios", icon: Calendar, testId: "horarios" },
        { to: "/admin/info-colegio", label: "Información del Colegio", icon: Building2, testId: "info-colegio" },
        { to: "/admin/reportes", label: "Reportes", icon: FilePieChart, testId: "reportes" },
        { to: "/admin/incidencias", label: "Incidencias", icon: AlertTriangle, testId: "incidencias" },
        { to: "/admin/asistencia", label: "Asistencia", icon: ClipboardCheck, testId: "asistencia" },
        { to: "/admin/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
    ejecutivo: [
        { to: "/ejecutivo/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "dashboard" },
        { to: "/ejecutivo/colegios", label: "Colegios", icon: Building2, testId: "colegios" },
        { to: "/ejecutivo/recomendaciones", label: "Recomendaciones", icon: Lightbulb, testId: "ejecutivo-recomendaciones" },
        { to: "/ejecutivo/estadisticas", label: "Estadísticas", icon: TrendingUp, testId: "estadisticas" },
        { to: "/ejecutivo/reportes", label: "Reportes", icon: FilePieChart, testId: "reportes" },
        { to: "/ejecutivo/admins", label: "Gestión de Usuarios", icon: Users, testId: "admins" },
        { to: "/ejecutivo/financiero", label: "Panel Financiero", icon: Briefcase, testId: "financiero" },
        { to: "/ejecutivo/actividad", label: "Actividad de Plataforma", icon: Activity, testId: "actividad" },
        { to: "/ejecutivo/perfil", label: "Mi Perfil", icon: UserCircle, testId: "perfil" },
    ],
};

export default function Layout() {
    const { user } = useAuth();
    const items = (user && ITEMS[user.role]) || [];
    return (
        <div className="flex h-screen bg-edu-bg">
            <Sidebar items={items} />
            <main id="main-content" className="flex-1 overflow-y-auto edu-scroll" tabIndex={-1}>
                <Outlet />
            </main>
        </div>
    );
}
